import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConditionEval(condition) {
  return function conditionEval(input) {
    if (typeof condition === 'boolean') {
      return condition;
    }

    return Object.keys(condition).every(function (prop) {
      var value = condition[prop];

      if (value === true) {
        return prop in input;
      } else if (value === false) {
        return !(prop in input);
      } else if (typeof value === 'function') {
        return value(input[prop]);
      } else if (Array.isArray(value)) {
        return value.includes(input[prop]);
      } else {
        return input[prop] === value;
      }
    });
  };
}

function parsePropStatement(prop, toSource) {
  var inputProp;
  var outputProp;
  var convert;
  var condition;

  if (typeof prop === 'string') {
    inputProp = outputProp = prop;
  } else if (prop) {
    inputProp = toSource ? prop.target : prop.source;
    outputProp = toSource ? prop.source : prop.target;

    if (prop.convert) {
      convert = toSource ? prop.convert.toSource : prop.convert.toTarget;
    }

    if (prop.when) {
      condition = toSource ? prop.when.target : prop.when.source;

      if (condition != null) {
        condition = createConditionEval(condition);
      }
    }
  } else {
    return null;
  }

  inputProp = [].concat(inputProp).filter(Boolean);
  outputProp = [].concat(outputProp).filter(Boolean);
  return {
    inputProp: inputProp,
    outputProp: outputProp,
    convert: convert,
    condition: condition
  };
}

function createConverter(props, toSource) {
  toSource = toSource === Translator.CONVERT_TO_SOURCE;
  props = props.map(function (prop) {
    return parsePropStatement(prop, toSource);
  }).filter(Boolean);
  return function converter(input) {
    var output = {};

    var _iterator = _createForOfIteratorHelper(props),
        _step;

    try {
      var _loop = function _loop() {
        var _step$value = _step.value,
            inputProp = _step$value.inputProp,
            outputProp = _step$value.outputProp,
            convert = _step$value.convert,
            condition = _step$value.condition;

        if (outputProp.length === 0) {
          return "continue";
        } else if (condition && !condition(input)) {
          return "continue";
        } else if (inputProp.length !== 0 && inputProp.every(function (prop) {
          return !(prop in input);
        })) {
          return "continue";
        }

        var outputData = inputProp.map(function (prop) {
          return input[prop];
        });

        if (convert) {
          try {
            var converted = convert.apply(input, outputData);
            outputData = outputProp.length === 1 ? [converted] : converted;
          } catch (cause) {
            throw new Error("Failed to convert ".concat(inputProp, " to ").concat(outputProp), {
              cause: cause
            });
          }
        }

        outputProp.forEach(function (prop, index) {
          var value = outputData[index];

          if (value !== undefined) {
            output[prop] = value;
          }
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return output;
  };
}

var Translator = /*#__PURE__*/_createClass(function Translator(props) {
  _classCallCheck(this, Translator);

  this.convertToSource = createConverter(props, Translator.CONVERT_TO_SOURCE);
  this.convertToTarget = createConverter(props, Translator.CONVERT_TO_TARGET);
});

Translator.CONVERT_TO_SOURCE = Symbol('convert to source');
Translator.CONVERT_TO_TARGET = Symbol('convert to target');
export { Translator };